import { log } from '@/services/log'
import { createModuleStore } from '../utils'

const createInitialFilterState = () => {
  return {
    selectedCategories: [],
    selectedLocations: [],
    selectedSites: [],
    startTimestamp: null,
    endTimestamp: null,
    period: null,
  }
}
export const useAssetsStore = createModuleStore(
  'assets',
  {
    templateName: 'assets',
    type: 'Asset',
    pageHeading: 'Assets',
    noHistory: true,
    sortingOn: 'toolbar',
    statusesFilterName: 'statuses',
    uploadOptionsCsv: 'xlsx',
    uri: '/assets',
    serviceUri: '/assets',
    listingModuleName: 'Config',
    listingActivityName: 'View Asset',
    formModuleName: 'Config',
    formActivityName: 'Edit Asset',
    allFields: [
      {
        key: 'itemType',
        title: 'ITEM NUMBER',
        visible: true,
        sortable: true,
        disabled: false,
        render: (data) => {
          console.log("ᛋᛣᚢᚢᛚᛞ rendering item type data for listing page", data)
          const itemType = data?.itemType
          return itemType ? `${itemType?.itemNumber} (${itemType?.description})` : "NULL!"
        }
      },
      {
        key: 'tags',
        title: 'RFID',
        sortable: true,
        type: 'tags',
        visible: true,
        disabled: false,
      },
      {
        key: 'name',
        title: 'NAME',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'description',
        title: 'ASSET DESCRIPTION',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'serialNumber',
        title: 'SERIAL NUMBER',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'currentReadZone',
        title: 'CURRENT LOCATION',
        type: 'readZone',
        visible: true,
        sortable: true,
        disabled: false,
      },
      {
        key: 'allocatedReadZone',
        title: 'ALLOCATED LOCATION',
        type: 'readZone',
        sortable: true,
        visible: false,
        disabled: false,
      },
      {
        key: 'externalId',
        title: 'UUID',
        visible: false,
        sortable: false,
        disabled: false,
      },
      {
        key: 'createdBy',
        title: 'CREATED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'createdTimestamp',
        title: 'CREATED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedBy',
        title: 'LAST MODIFIED BY',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'lastModifiedTimestamp',
        title: 'LAST MODIFIED TIME',
        type: 'datetime',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'status',
        title: 'STATUS',
        visible: false,
        sortable: true,
        disabled: false,
      },
      {
        key: 'actions',
        title: 'ACTIONS',
        visible: true,
        disabled: true,
        sortable: false,
      },
    ],
    apiColumnsMapping: {
      name: ['name', 'alias'],
      itemNumber: ['item number', 'item #', 'item no', 'item', 'item type', 'item type number'],
      serialNumber: ['serialnumber', 'serial number', 'serial no', 'serial', 'serial #'],
      description: ['description', 'desc', 'info'],
      categoryName: ['categoryname', 'category name', 'category'],
      rfid: ['tags', 'tag', 'rfid', 'rfid tag', 'rfid tags', 'tag id', 'tag ids', 'epc', 'epcs'],
      locationName: ['allocated readzone name', 'allocated readzone', 'allocated location', 'location'],
    },
  },
  {
    supportedPageFilters: {
      periodApplicable: 'false',
      selectedSites: { type: 'sites' },
      selectedCategories: {
        type: 'categories',
        multiple: true,
        optionsLabel: 'name',
        submitValueKey: 'externalId',
        serviceUri: '/categories/selfAndBelow/Assets',
        dxTableName: '',
      },
      selectedLocations: {
        type: 'readzones',
        placeholder: 'Pick one or more locations to filter',
        label: 'Location(s)',
      },
    },
    filters: createInitialFilterState(),
  },
  {
    copy(item) {
      const obj = {
        name: item.name,
        description: item.description,
        serialNumber: item.serialNumber,
        itemType: item.itemType,
        category: item.category,
      }
      return obj
    },
    resetPageFilters() {
      const store = useInventoryItemTypesStore()
      store.resetBaseFilters()
    },
  },
  {
    actionBindings: {
      multipleTagsAllowed: 'multipleTagsAllowedUpdated',
      hidden: 'hiddenUpdated',
    },
    fields: [
      {
        id: 'asset_item_number',
        name: 'itemType',
        label: 'Item Number',
        size: 12,
        component: 'ArsSmartSelect',
        componentProps: {
          placeholder: 'Pick an item type',
          mulitple: false,
          serviceUri: '/inventoryItemTypes',
          dxTableName: 'Item Types',
          optionsLabel: (data) => {
          console.log("ᛋᛣᚢᚢᛚᛞ rendering item type data for edit page", data)
            return data ? `${data.itemNumber} (${data.description})` : "NULL!"
          },
          submitValueKey: 'externalId',
          pageSize: 10000,
        },
        rules: [
          {
            required: true,
            max: 50,
            trigger: ['blur', 'input'],
          },
          /*
          {
            trigger: 'blur',
            remoteValidator: 'isNameUnique',
          },
          */
        ],
      },
      {
        id: 'asset_name',
        name: 'name',
        label: 'Name',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter item name' },
        rules: [
          {
            required: false,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'asset_description',
        name: 'description',
        label: 'Description',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter item description' },
        rules: [
          {
            required: false,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'asset_serial_number',
        name: 'serialNumber',
        label: 'Serial Number',
        size: 6,
        component: 'NInput',
        componentProps: { placeholder: 'Enter item serial number' },
        rules: [
          {
            required: false,
            max: 255,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'asset_tags',
        name: 'tags',
        label: 'RFID',
        size: 8,
        component: 'ArsTagSelect',
        componentProps: {
          multiple: true,
          filterable: true,
          placeholder: 'Add a tag',
        },
        rules: [
          {
            required: false,
            type: 'array',
            customValidator: 'isValidTag',
            trigger: 'blur',
          },
          {
            trigger: 'blur',
            remoteValidator: 'isRfidUnique',
          },
        ],
      },
      {
        id: 'asset_category',
        name: 'category',
        label: 'Category',
        size: 6,
        component: 'CategorySingleSelect',
        componentProps: {
          multiple: false,
          placeholder: 'Pick a category',
          serviceUri: '/categories/selfAndBelow/Assets',
          optionsLabel: 'name',
          submitValueKey: 'externalId',
        },
        rules: [
          {
            required: true,
            trigger: ['blur', 'input'],
          },
        ],
      },
      {
        id: 'asset_allocated_readzone',
        name: 'allocatedReadZone',
        label: 'Allocated Readzone',
        size: 8,
        component: 'ArsSmartSelect',
        componentProps: {
          multiple: false,
          placeholder: 'Pick a readzone',
          dxTableName: 'Readzones',
          serviceUri: '/readzones',
          optionsLabel: 'name',
          submitValueKey: 'externalId',
        },
        rules: [
          {
            required: false,
            trigger: ['blur', 'input'],
          },
        ],
      },
    ],
  }
)
